module.exports = __webpack_public_path__ + "img/certificate-4.f17e0619.jpg";